var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.596.923a1.15 1.15 0 0 1 1.27.32l1.232 1.411L8.15 1.086a1.15 1.15 0 0 1 1.397 0l2.21 1.69 2.212-1.69a1.15 1.15 0 0 1 1.406.008l2.085 1.63 1.775-1.582A1.15 1.15 0 0 1 21.15 2v20a1.15 1.15 0 0 1-1.915.858l-1.775-1.582-2.085 1.63a1.15 1.15 0 0 1-1.406.008l-2.211-1.69-2.211 1.69a1.15 1.15 0 0 1-1.397 0l-2.052-1.568-1.231 1.41A1.15 1.15 0 0 1 2.85 22V2c0-.48.297-.908.746-1.077ZM8.85 3.447l-2.211 1.69a1.15 1.15 0 0 1-1.488-.078V18.94a1.15 1.15 0 0 1 1.488-.077l2.21 1.689 2.212-1.69a1.15 1.15 0 0 1 1.396 0l2.203 1.684 2.142-1.675a1.15 1.15 0 0 1 1.474.048l.575.513V4.567l-.576.513a1.15 1.15 0 0 1-1.473.048L14.66 3.453l-2.203 1.683a1.15 1.15 0 0 1-1.396 0L8.849 3.447Z",
    fill: "#4965A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V8.2a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1.3Zm0 6a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1.3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1.3Z",
    fill: "#4965A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.d59d5ee8127eefd903a5eca018affd5f.svg";
export { ForwardRef as ReactComponent };